"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractPageTypeFromUrl = exports.santizeEmbedUrl = exports.sanitizeHostUrl = exports.IS_URL = exports.escapeFilterParam = exports.stringify = void 0;
function stringify(params) {
    var result = [];
    for (var key in params) {
        var value = params[key];
        var valueArray = Array.isArray(value) ? value : [value];
        for (var _i = 0, valueArray_1 = valueArray; _i < valueArray_1.length; _i++) {
            var singleValue = valueArray_1[_i];
            result.push("".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(singleValue)));
        }
    }
    return result.join('&');
}
exports.stringify = stringify;
function escapeFilterParam(param) {
    return param.replace(/,/g, '^,');
}
exports.escapeFilterParam = escapeFilterParam;
exports.IS_URL = /^https?:\/\//;
function sanitizeHostUrl(hostUrl) {
    try {
        var protocol = hostUrl.startsWith('https://') || hostUrl.startsWith('http://')
            ? ''
            : 'https://';
        var url = new URL("".concat(protocol).concat(hostUrl));
        return "".concat(url.hostname).concat(['', '443', '80'].includes(url.port) ? '' : ':' + url.port);
    }
    catch (error) {
        throw new Error("Invalid host URL ".concat(hostUrl));
    }
}
exports.sanitizeHostUrl = sanitizeHostUrl;
function santizeEmbedUrl(embedUrl) {
    var urlString = embedUrl;
    if (embedUrl.startsWith('https://') || embedUrl.startsWith('http://')) {
        try {
            var url = new URL(embedUrl);
            urlString = "".concat(url.pathname).concat(url.search).concat(url.hash);
        }
        catch (error) {
            throw new Error("Invalid embed URL ".concat(embedUrl));
        }
    }
    if (!urlString.startsWith('/embed')) {
        urlString = "/embed".concat(urlString);
    }
    return urlString;
}
exports.santizeEmbedUrl = santizeEmbedUrl;
var validPageTypes = [
    'dashboards',
    'explore',
    'merge',
    'looks',
    'extensions',
    'message',
    'query',
    'preload',
    'query-visualization',
    'reporting',
];
function extractPageTypeFromUrl(url) {
    var _a;
    var pageType = (_a = url.split('?')[0]) === null || _a === void 0 ? void 0 : _a.split('/')[2];
    return validPageTypes.includes(pageType) ? pageType : 'unknown';
}
exports.extractPageTypeFromUrl = extractPageTypeFromUrl;
//# sourceMappingURL=utils.js.map